import { HttpParams } from '@angular/common/http';
import { Service } from '@angular/core';
import { map, Observable } from 'rxjs';
import { DailyHistoryListData } from '../models/daily-history.model';
import { KalaApiResponse } from '../models/kala-api.model';
import { BaseService } from './base.service';

export interface DailyHistoryQuery {
	contractId: number;
	pageNumber: number;
	pageSize: number;
}

@Service()
export class DailyHistoryService extends BaseService {
	getDailyHistory(query: DailyHistoryQuery): Observable<DailyHistoryListData> {
		return this.http
			.get<KalaApiResponse<DailyHistoryListData>>(`${this.kalaApiPath}/symbols/dailyhistory`, {
				params: new HttpParams()
					.set('ContractId', query.contractId)
					.set('PageNumber', query.pageNumber)
					.set('PageSize', query.pageSize)
			})
			.pipe(
				map(response => {
					if (!response.isSuccessful) {
						throw new Error(response.error?.message ?? 'دریافت سابقه معاملات انجام نشد');
					}

					return response.data ?? { items: [], totalCount: 0 };
				})
			);
	}
}
